import fpApiUtil from "./fp-api-util";

const ANALYSIS = "factoryplan/analysis";

// 자원별 작업 배치 목록(활동 전/후 연관 공정 포함) — AnalysisController#getDispatchList(백엔드는
// factoryplan/analysis/dispatch-list). 다른 Report 화면과 달리 크로스탭이 아니라 평평한 목록
// { data: DispatchListDto[] }을 그대로 내려준다(fp-report-screen-guide.md §B). old도 그리드 조회
// (loadData)만 있고 별도 차트/드릴다운 호출이 없어 이 함수 하나면 충분하다.
const getDispatchList = (params) => fpApiUtil.postParams(`${ANALYSIS}/dispatch-list`, params);

const fpDispatchListService = { getDispatchList };
export default fpDispatchListService;
